// Navigation permissions mapping
export const NAVIGATIONPERMISSIONS = {
  dashboard: [] as App.Enums.PermissionEnum[], // No specific permission required - all authenticated users can access
  communications: ["view-channels" as App.Enums.PermissionEnum],
  chat: ["view-channels" as App.Enums.PermissionEnum],
  mail: ["view-channels" as App.Enums.PermissionEnum],
  socialComments: ["view-social-comments" as App.Enums.PermissionEnum],
  forms: ["view-forms" as App.Enums.PermissionEnum],
  contacts: [] as App.Enums.PermissionEnum[], // Contacts can be accessed independently
  deals: ["view-deals" as App.Enums.PermissionEnum],
  tickets: ["view-tickets" as App.Enums.PermissionEnum], // Assuming tickets are related to channel viewing
  automations: ["manage-automations" as App.Enums.PermissionEnum],
  widgets: ["manage-integrations" as App.Enums.PermissionEnum],
  chatWidgets: ["manage-integrations" as App.Enums.PermissionEnum],
  quickReplies: ["manage-quick-replies" as App.Enums.PermissionEnum],
  conversationCategories: ["manage-conversation-categories" as App.Enums.PermissionEnum],
} as const;

// Navigation feature flags mapping
export const NAVIGATIONFEATUREFLAGS = {
  communications: null, // Special case - requires either chat_channels OR email_channels
  chat: "chat_channels" as App.Enums.PlanFeatureCodeEnum,
  mail: "email_channels" as App.Enums.PlanFeatureCodeEnum,
  socialComments: "social_comments" as App.Enums.PlanFeatureCodeEnum,
  forms: null,
  automations: "automation" as App.Enums.PlanFeatureCodeEnum,
  agents: "agents" as App.Enums.PlanFeatureCodeEnum,
  widgets: null, // Special case - requires either chat_channels OR email_channels
  contacts: "contacts" as App.Enums.PlanFeatureCodeEnum,
  chatWidgets: "chat_channels" as App.Enums.PlanFeatureCodeEnum,
  quickReplies: "chat_channels" as App.Enums.PlanFeatureCodeEnum,
  conversationCategories: "chat_channels" as App.Enums.PlanFeatureCodeEnum,
} as const;

// Helper type for navigation keys
export type NavigationKey = keyof typeof NAVIGATIONPERMISSIONS;
